import { Box, Chip, TextField, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
    minWidth: 0,
    "& .MuiAutocomplete-inputRoot": {
      flexWrap: "nowrap !important",
      overflow: "hidden",
      alignItems: "center",
    },
    "& .MuiAutocomplete-tag": {
      maxWidth: "calc(100% - 36px)",
      margin: "1px 2px 1px 0 !important",
    },
    "& .MuiChip-root": {
      height: 20,
      maxWidth: "100%",
    },
    "& .MuiChip-label": {
      paddingLeft: 4,
      paddingRight: 4,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "flex",
      alignItems: "center",
    },
  },
  optionRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 13,
    minWidth: 0,
    width: "100%",
  },
  colorDot: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    flexShrink: 0,
    border: "1px solid rgba(0,0,0,0.12)",
  },
  optionName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  chipLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    maxWidth: "100%",
    overflow: "hidden",
  },
  chipName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 72,
    fontSize: "0.62rem",
  },
  limitTag: {
    height: 20,
    fontSize: "0.62rem",
    backgroundColor: "rgba(0,0,0,0.08)",
    margin: "1px 0 !important",
  },
}));

const TagColorDot = ({ color, size = 12 }) => (
  <span
    style={{
      width: size,
      height: size,
      borderRadius: "50%",
      backgroundColor: color || "#eee",
      flexShrink: 0,
      border: "1px solid rgba(0,0,0,0.12)",
      display: "inline-block",
    }}
  />
);

const renderTagChipLabel = (option, classes) => (
  <span className={classes.chipLabel}>
    <TagColorDot color={option.color} size={10} />
    <span className={classes.chipName}>{option.name}</span>
  </span>
);

export function TagsFilter({ onFiltered }) {
  const classes = useStyles();
  const [tags, setTags] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadTags();
    }
    fetchData();
  }, []);

  const loadTags = async () => {
    try {
      const { data } = await api.get(`/tags/list`);
      setTags(data);
    } catch (err) {
      toastError(err);
    }
  };

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box className={classes.root}>
      <Autocomplete
        multiple
        size="small"
        options={tags}
        value={selecteds}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(option) => option.name || ""}
        renderOption={(option) => (
          <div className={classes.optionRow}>
            <TagColorDot color={option.color} />
            <span className={classes.optionName}>{option.name}</span>
          </div>
        )}
        renderTags={(value, getTagProps) => {
          if (!value.length) return null;

          if (value.length === 1) {
            const option = value[0];
            return [
              <Chip
                key={option.id || option.name}
                variant="outlined"
                style={{
                  backgroundColor: option.color || "#eee",
                  color: "#fff",
                  textShadow: "1px 1px 1px rgba(0,0,0,0.35)",
                }}
                label={renderTagChipLabel(option, classes)}
                {...getTagProps({ index: 0 })}
                size="small"
              />,
            ];
          }

          return [
            <Chip
              key="tags-summary"
              className={classes.limitTag}
              size="small"
              label={
                <span className={classes.chipLabel}>
                  <TagColorDot color={value[0].color} size={10} />
                  <span className={classes.chipName}>
                    {value.length} tags
                  </span>
                </span>
              }
              onDelete={() => onChange([])}
            />,
          ];
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={selecteds.length ? "" : "Tags"}
          />
        )}
      />
    </Box>
  );
}
